import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet";
import ContactDetails from "../components/contact/ContactDetails";
import HeaderSection from "../components/contact/HeaderSection";
import { useNavigate } from "react-router-dom";


const ContactPage = () => {
  const [result, setResult] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  
  const onSubmit = async (event) => {
    event.preventDefault();
    setResult("Sending...");

    const formData = new FormData(event.target);
    formData.append("access_key", "722f55d1-77c0-4b64-ae65-0badf1afd471"); 

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData,
    });

    const data = await response.json();

    if (data.success) {
      setResult("Form Submitted Successfully!");
      event.target.reset();
      setTimeout(() => navigate("/thankyou"), 1500); 
    } else {
      console.error("Error:", data);
      setResult(data.message);
    }
  };

  return (
    <>
      <Helmet>
        <title>Contact Beyond Bloom | Get in Touch with Us</title>
        <meta
          name="description"
          content="Reach out to Beyond Bloom for inquiries, collaborations, or expert advice. Get in touch via phone, email, or our contact form."
        />
        <meta
          name="keywords"
          content="Beyond Bloom contact, customer support, business inquiries, contact form, get in touch, reach us, Beyond Bloom support"
        />
      </Helmet>

      <Navbar />
      <div className="min-h-screen bg-gradient-to-b from-black via-green-900 to-black text-white flex flex-col items-center p-6">
        {/* Header Section */}
        <HeaderSection />

        {/* Contact Form */}
        <motion.form
          className="w-full max-w-2xl bg-green-700 p-8 rounded-lg shadow-lg mb-10"
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.8 }}
          onSubmit={onSubmit}
        >
          <div className="grid grid-cols-1 gap-6">
            {/* Name */}
            <div>
              <label className="block text-white font-medium mb-1" htmlFor="name">
                Name
              </label>
              <input
                type="text"
                id="name"
                name="name"
                placeholder="Enter your name"
                required
                className="w-full p-3 rounded bg-black text-white border border-gray-400 focus:outline-none focus:ring-2 focus:ring-green-500"
              />
            </div>

            {/* Email */}
            <div>
              <label className="block text-white font-medium mb-1" htmlFor="email">
                Email
              </label>
              <input
                type="email"
                id="email"
                name="email"
                placeholder="Enter your email"
                required
                className="w-full p-3 rounded bg-black text-white border border-gray-400 focus:outline-none focus:ring-2 focus:ring-green-500"
              />
            </div>

            {/* Message */}
            <div>
              <label className="block text-white font-medium mb-1" htmlFor="message">
                Message
              </label>
              <textarea
                id="message"
                name="message"
                placeholder="Type your message..."
                rows="4"
                required
                className="w-full p-3 rounded bg-black text-white border border-gray-400 focus:outline-none focus:ring-2 focus:ring-green-500"
              ></textarea>
            </div>

            {/* Terms and Conditions */}
            <div className="flex items-center gap-2">
              <input
                type="checkbox"
                id="terms"
                name="terms"
                required
                className="w-5 h-5 text-green-500 focus:ring-green-500 rounded"
              />
              <label htmlFor="terms" className="text-white">
                I accept the Terms and Conditions
              </label>
            </div>

            {/* Submit Button */}
            <div>
              <motion.button
                type="submit"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="w-full bg-black text-green-400 font-bold py-3 px-6 rounded hover:bg-green-500 hover:text-black transition-all"
              >
                Send Message
              </motion.button>
            </div>

            {/* Submission Status */}
            {result && <p className="text-white text-center mt-3">{result}</p>}
          </div>
        </motion.form>

        {/* Contact Details Section */}
        <ContactDetails />
      </div>
      <Footer />
    </>
  );
};

export default ContactPage;
